module.exports = __webpack_public_path__ + "img/icon-portugues-colorido.fde5de87.svg";